var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mt-4" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("plain-text-control", {
          attrs: {
            title: _vm.title,
            required: _vm.required,
            instructionKey: _vm.instructionKey
          }
        }),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass: "table tablerow",
            attrs: { id: "", "aria-label": _vm.$t(_vm.title) }
          },
          [
            _c("thead", [
              _c("tr", [
                _c("th", { staticClass: "w-70" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t(_vm.columnHeader)))])
                ]),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "w-15 right",
                    attrs: { id: _vm.title + "_euro" }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("Euro")))])]
                ),
                _vm._v(" "),
                _vm._m(0)
              ])
            ]),
            _vm._v(" "),
            _vm._l(_vm.items, function(item, index) {
              return _vm.items.length > 0
                ? _c("tbody", [
                    _c(
                      "tr",
                      { staticClass: "aidapplications-main-row border-0" },
                      [
                        _c(
                          "th",
                          { staticClass: "row-heading" },
                          [
                            _c("plain-text-control", {
                              attrs: { title: item.name, noMargin: true }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "input-cell" },
                          [
                            _c("numeric-input-control", {
                              attrs: {
                                disabled: _vm.isReadOnly,
                                placeholderKey: "EnterValue",
                                required: true,
                                labelledBy: _vm.title + "_euro"
                              },
                              model: {
                                value: item.amount,
                                callback: function($$v) {
                                  _vm.$set(item, "amount", $$v)
                                },
                                expression: "item.amount"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "right disabled" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatPercentage")(item.percentage)
                              )
                            )
                          ])
                        ])
                      ]
                    )
                  ])
                : _vm._e()
            }),
            _vm._v(" "),
            _c("tfoot", [
              _c("tr", [
                _c("th", { staticClass: "row-heading bold" }, [
                  _c("div", { staticClass: "d-none d-xl-block" }, [
                    _vm._v(_vm._s(_vm._f("toUpperCase")(_vm.$t("Total"))))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-block d-xl-none" }, [
                    _vm._v(_vm._s(_vm._f("toUpperCase")(_vm.$t("Total_Short"))))
                  ])
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "right" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("formatNumber")(_vm.amountSum)))
                  ])
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "disabled" })
              ])
            ])
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", { staticClass: "w-15 right" }, [_c("span", [_vm._v("%")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }